export default "__VITE_ASSET__CcxVc_OR__"